import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Field } from 'redux-form';
import { getGameTransactionLabel } from '../../../../../constants/gameTransactionTypes';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import NativeSelect from '@mui/material/NativeSelect';
import gameService from '../../../../../services/game.service';
import DeleteIcon from '@mui/icons-material/Delete';
import { Stack } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import { __SetFilter } from '../../../../../actions/AsyncTable';
import store from './../../../../../store';

const renderTransactionsField = ({ input, meta: { touched, error }, options, i18n, ...custom }) => {
    return (
        <NativeSelect {...input} {...custom}>
            <option value="">{i18n.t('filter.choose_transaction')}</option>
            {options.map(item => (
                <option key={item.id} value={item.id}>
                    {getGameTransactionLabel(item.title)}
                </option>
            ))}
        </NativeSelect>
    );
};

export default data => {
    const { i18n } = useTranslation();
    const [transactionOptions, setTransactionOptions] = useState([]);

    useEffect(() => {
        const fetchTransactions = async () => {
            try {
                const { list } = await gameService.GetGameTransactions();
                const transactions = list.map(item => ({
                    id: item.value,
                    title: item.value,
                }));
                setTransactionOptions(transactions);
            } catch (error) {
                console.error(error);
            }
        };
        fetchTransactions();
    }, []);

    return (
        <Card>
            <CardContent>
                <div style={{ display: 'flex', marginBottom: 16 }}>
                    <Stack spacing={3} direction={'row'} alignItems={'center'}>
                        <Typography gutterBottom variant="h6" component="h2">
                            {i18n.t(data.label)}
                        </Typography>
                        <IconButton onClick={() => __SetFilter()(store.dispatch, store.getState)(data)}>
                            <DeleteIcon />
                        </IconButton>
                    </Stack>
                </div>
                <Field
                    name={data.code}
                    i18n={i18n}
                    options={transactionOptions}
                    component={renderTransactionsField}
                    type="text"
                />
            </CardContent>
        </Card>
    );
};
